<div *ngIf="mainPageLoader" class="loading-shade">
    <div class="loader" alt="Please wait..."></div>
</div>
<div *ngIf="!mainPageLoader" class="container-fluid d-flex align-items-center justify-content-center" [ngStyle]="{'height': (hideForm || apiFailMsg || apiSuccessMsg) ? '500px' : 'auto'}">
    <div class="row m-0 d-flex justify-content-center">
        <div *ngIf="!hideForm && !apiFailMsg && !apiSuccessMsg" class="col-12 col-md-7 col-lg-5 col-xl-4 my-3 feedback_wrapper">
            <form [formGroup]="docsSecondFeedbackForm" (ngSubmit)="onSubmitForm()">
                <div class="row m-0">
                    <div class="col-12 mb-2 text-center form_title">
                        {{ 'avayaDocFeedback' | translate }}
                    </div>
                    <div class="col-12 mb-3">
                        <p class="mb-1 font_size fw-bold">
                            <span class="red-color">*</span>&nbsp;
                            <label for="topic1">{{ topic1Label }}</label>
                        </p>
                        <input id="topic1" type="text" formControlName="topic1" class="form-control input_font text_field" placeholder="Enter {{ topic1Label }}" required
                            [ngStyle]="{'background-color': p2Val ? '#e7e7e7' : 'white'}" />
                    </div>
                    <div class="col-12 mb-3">
                        <p class="mb-1 font_size fw-bold">
                            <span class="red-color">*</span>&nbsp;
                            <label for="topic2">{{ topic2Label }}</label>
                        </p>
                        <input id="topic2" type="text" formControlName="topic2" class="form-control input_font text_field" placeholder="Enter {{ topic2Label }}" required
                            [ngStyle]="{'background-color': p3Val ? '#e7e7e7' : 'white'}" />
                    </div>
                    <div class="col-12 mb-3">
                        <p class="mb-1 font_size fw-bold">
                            <span class="red-color">*</span>&nbsp;
                            <label for="options">{{ 'selectAnyOpt' | translate }}</label>
                        </p>
                        <select id="options" formControlName="options" class="form-control input_font text_field" (change)="userSelectOption()" required>
                            <option value="" disabled selected>{{ 'selectOpt' | translate }}</option>
                            <option value="The content is incorrect">{{ 'contectCorrect' | translate }}</option>
                            <option value="The topic or manual is missing information">{{ 'topicManualInfo' | translate }}</option>
                            <option value="I cannot find the information I am looking for">{{ 'canNotFindInfo' | translate }}</option>
                            <option value="I need help with a password or logon">{{ 'needHelpWithPwdLogin' | translate }}</option>
                            <option value="I have a question about the product">{{ 'haveQueAbtProduct' | translate }}</option>
                            <option value="The product is not working as expected/documented">{{ 'productNotWorking' | translate }}</option>
                            <option value="I found a broken link">{{ 'foundBrokenLink' | translate }}</option>
                            <option value="Other">{{ 'other' | translate }}</option>
                        </select>
                    </div>
                    <div *ngIf="hide" class="col-12 mb-3">
                        <p class="mb-1 font_size fw-bold">
                            <span class="red-color">*</span>&nbsp;
                            <label for="userName">{{ 'yourName' | translate }}</label>
                        </p>
                        <input id="userName" type="text" formControlName="name" class="form-control input_font text_field" placeholder="{{ 'pleaseProvideName' | translate }}" />
                        <p *ngIf="docsSecondFeedbackForm.get('name').touched && docsSecondFeedbackForm.get('name').errors?.required" class="ps-2 red-color small">
                            {{ 'fieldRequired' | translate }}
                        </p>
                    </div>
                    <div *ngIf="hide" class="col-12 mb-3">
                        <p class="mb-1 font_size fw-bold">
                            <span class="red-color">*</span>&nbsp;
                            <label for="userEmail">{{ 'yourEmail' | translate }}</label>
                        </p>
                        <input id="userEmail" type="email" formControlName="email" class="form-control input_font text_field" placeholder="{{ 'pleaseProvideEmail' | translate }}" />
                        <p *ngIf="docsSecondFeedbackForm.get('email').touched && docsSecondFeedbackForm.get('email').errors?.required" class="ps-2 red-color small">
                            {{ 'fieldRequired' | translate }}
                        </p>
                        <p *ngIf="docsSecondFeedbackForm.get('email').touched && docsSecondFeedbackForm.get('email').errors?.pattern" class="ps-2 red-color small">
                            {{ 'properEmailFormat' | translate }}
                        </p>
                    </div>
                    <div *ngIf="hide" class="col-12 mb-3">
                        <p class="mb-1 font_size fw-bold">
                            <span class="red-color">*</span>&nbsp;
                            <label for="userConfirmEmail">{{ 'confirmEmail' | translate }}</label>
                        </p>
                        <input id="userConfirmEmail" type="email" formControlName="confirm_email" class="form-control input_font text_field" placeholder="{{ 'confirmEmail' | translate }}" (focusout)="checkEmail()" />
                        <p *ngIf="docsSecondFeedbackForm.get('confirm_email').touched && docsSecondFeedbackForm.get('confirm_email').errors?.required" class="ps-2 red-color small">
                            {{ 'fieldRequired' | translate }}
                        </p>
                        <p *ngIf="!isValid && docsSecondFeedbackForm.controls['confirm_email'].touched" class="ps-2 red-color small">
                            {{ 'emailMatch' | translate }}
                        </p>
                    </div>
                    <div *ngIf="hide" class="col-12 mb-3">
                        <p class="mb-1 font_size fw-bold">
                            <span class="red-color">*</span>&nbsp;
                            <label for="userDescription">{{ 'description' | translate }}</label>
                        </p>
                        <textarea id="userDescription" formControlName="description" class="form-control input_font text_field" placeholder="{{ 'description' | translate }}" rows="4"></textarea>
                        <p *ngIf="docsSecondFeedbackForm.get('description').touched && docsSecondFeedbackForm.get('description').errors?.required" class="ps-2 red-color small">
                            {{ 'fieldRequired' | translate }}
                        </p>
                    </div>
                    <div *ngIf="hide" class="col-12 mb-3 d-flex justify-content-center flex-column">
                        <!-- <re-captcha (resolved)="resolved($event)" siteKey="{{ captchaKey }}"></re-captcha> -->
                        <cop-turnstile-captcha (resolvedToken)="handleCaptcha($event)"></cop-turnstile-captcha>
                        <p class="d-flex justify-content-center align-items-center" *ngIf="isValidatingCaptchaToken">
                            <img class="me-2" src="/cs/cop/assets/images/ajax-loader.gif" alt="loader" width="25" height="25" />
                            <span class="red-color small">{{ 'verifyTokenMsg' | translate }}...</span>
                        </p>
                        <p class="d-flex justify-content-center align-items-center red-color" *ngIf="(tokenAPICallCnt > 0) && !captchaSucces">
                            <mat-icon class="me-2">cancel</mat-icon>
                            <span class="small">{{ 'tokenNotVerified' | translate }}</span>
                        </p>
                    </div>
                    <div *ngIf="!hide && msg1" class="col-12 mb-3">
                        <p>{{ 'thanksForContact' | translate }}</p>
                        <p>{{ 'avayaTechFeedback' | translate }}</p>
                        <p>{{ 'logonPwdConfigSoln' | translate }}</p>
                    </div>
                    <div *ngIf="!hide && msg2" class="col-12 mb-3">
                        <p>{{ 'thanksForContact' | translate }}</p>
                        <p>{{ 'forProdSalesPrice' | translate }} <a href="www.avaya.com" target="_blank" style="color: dodgerblue;" rel="noopener">www.avaya.com</a>, {{ 'partnerLocator' | translate }}:
                            <a href="https://www.avaya.com/en/partner-locator/" target="_blank" style="color: dodgerblue;" rel="noopener">https://www.avaya.com/en/partner-locator/</a>
                        </p>
                        <p>{{ 'contactAvayaSalesDirect' | translate }}: <a href="https://www.avaya.com/en/contacts/" target="_blank" rel="noopener" style="color: dodgerblue;">https://www.avaya.com/en/contacts/</a></p>
                    </div>
                    <div *ngIf="!hide && msg3" class="col-12 mb-3">
                        <p>{{ 'thanksForContact' | translate }}</p>
                        <p>{{ 'supportQuery' | translate }}</p>
                        <p>{{ 'investigateResolution' | translate }}</p>
                        <p>{{ 'goToSupportSite' | translate }}, <a href="https://support.avaya.com/contact/" target="_blank" rel="noopener" style="color: dodgerblue;">https://support.avaya.com/contact/</a>.
                            {{ 'requestDirectSupport' | translate }}.
                        </p>
                    </div>
                    <div *ngIf="!msg1 && !msg2 && !msg3" class="col-12 text-center">
                        <button type="submit" class="btn submit_btn">{{ 'OneCareSubmit' | translate }}</button>
                    </div>
                </div>
            </form>
        </div>
        <div *ngIf="hideForm" class="col-12 bg-white text-center msg_box_styling">
            <p><mat-icon class="red-color" aria-hidden="false">sentiment_very_dissatisfied</mat-icon></p>
            <p>{{ 'somethingWentWrong' | translate }}...!</p>
            <p>{{ 'brokenLink' | translate }}.</p>
        </div>
        <div *ngIf="apiFailMsg" class="col-12 bg-white text-center msg_box_styling">
            <p><mat-icon class="red-color" aria-hidden="false">cancel</mat-icon></p>
            <p>{{ 'somethingWentWrong' | translate }}...!</p>
            <p>{{ 'tryAgainLater' | translate }}.</p>
        </div>
        <div *ngIf="apiSuccessMsg" class="col-12 bg-white text-center msg_box_styling">
            <p><mat-icon style="color: dodgerblue;" aria-hidden="false">thumb_up</mat-icon></p>
            <p>{{ 'thankYouForFeedback' | translate }}.</p>
            <p>{{ 'closeThisPage' | translate }}.</p>
        </div>
    </div>
</div>
